export const JPEG_TAG = 'data:image/jpeg;base64,';
export const PNG_TAG = 'data:image/png;base64,';
